import React from 'react';

import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';

import { useAuth } from '@hooks';
import FormPerson from './FormPerson';
import FormCommerce from './FormCommerce';

const Card = styled.div`
  padding: 32px 32px 50px 32px;
  background-color: #fff;
  width: 500px;
  border-radius: 6px;
`;

const Title = styled.h3(
  ({ theme }) => css`
    margin-top: 0;
    margin-bottom: 26px;
    ${theme.textTypes['H6-w400']};
    color: ${theme.colors.gray800};
  `
);

const EditFormCommerce = ({ edit }) => {
  const { t } = useTranslation();
  const { isLegalEntity } = useAuth();

  return (
    <Card>
      {edit && <Title>{t('commerceData.editCommerce.subtitle')}</Title>}
      {isLegalEntity() ? <FormCommerce edit /> : <FormPerson edit />}
    </Card>
  );
};

export default EditFormCommerce;
